import React from 'react';
import NavbarDefault from "../components/navbarDefault";
import FooterDefault from "../components/footerDefault";
import { Divider, Grid, Typography, List, ListItem } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import { createTheme, responsiveFontSizes } from '@mui/material';
import { ThemeProvider } from '@emotion/react';

let theme = createTheme({
  typography: {
    fontFamily: [
      'Segoe UI', 
      'sans-serif',
    ].join(','),
  }
});

theme = responsiveFontSizes(theme);

function createCurData(S1, U1, S2, U2){
    return {S1, U1, S2, U2};
}

const first =[
    createCurData('Bioinfo 201', 3, 'Bioinfo 204', 3),
    createCurData('Bioinfo 202', 3, 'Bioinfo 205', 3),
    createCurData('Bioinfo 203', 3, 'Bioinfo 296', 1),
    createCurData('Elective 1', 3, 'Elective 2', 3),
];

const second = [
    createCurData('Bioinfo 271', 3, 'Bioinfo 300', 3),
    createCurData('Bioinfo 300', 3, '', ''),
    createCurData('Elective 3', 3, '', ''),
    createCurData('Elective 4', 3, '', ''),
];

function createCourseData(Bioinfo, Name, Description){
    return {Bioinfo, Name, Description};
}

const core = [  
    createCourseData(201, "Foundations of Bioinformatics", "3 units"),
    createCourseData(202, "Statistics for Bioinformatics", "3 units"),
    createCourseData(203, "Bioinformatics Software Engineering", "3 units"),
    createCourseData(204, "Computational Methods for Analyzing Nucleic Acids and Proteins", "Prereq: Bioinfo 201. 3 units"),
    createCourseData(205, "Fundamentals of Computational Biology", "Prereq: Bioinfo 201, Bioinfo 202. 3 units"),
];

const required = [  
    createCourseData(271, "Ethical, Legal and Social Issues in Bioinformatics", "Prereq: Bioinfo 201. 3 units"),
    createCourseData(296, "Graduate Seminar", "1 unit"),
    createCourseData(300, "Bioinformatics Software Engineering", "6 units"),
];

function MSBI() {
    return(
        <ThemeProvider theme={theme}>
            <NavbarDefault />
                <Grid         
                    container
                    direction="row"
                    justifyContent="center"
                    height="50%"
                    sx={{ flexGrow: 1, 
                    paddingBottom: 2,
                    paddingRight: 2,
                    marginTop: 2,
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginBottom: 5,
                    maxWidth: 1,
                    alignItems: "center"
                    }}
                    spacing={2}
                >
                    <Grid item xs={8} sx={{textAlign: 'justify'}}>
                        <Typography variant='h4' fontFamily="Segoe UI" fontWeight={700} marginBottom={4}>
                            MASTERS OF SCIENCE IN BIOINFORMATICS
                        </Typography>
                        <Grid item xs={8} sx={{textAlign:'justify'}}>

                            <Typography variant='h5' fontFamily="Segoe UI" fontWeight={700} gutterBottom>
                                PROGRAM SUMMARY
                            </Typography>
                            <Typography variant='b1' fontFamily="Segoe UI">
                                The MS Bioinformatics program will focus solely on the theoretical and practical aspects of bioinformatics. A multidisciplinary approach would be adopted to imbue both computation-centric and life science-centric aspects expected from a bioinformatician.
                            </Typography>
                            <Typography sx={{mt:2}} variant='h6' fontFamily="Segoe UI" fontWeight={700} gutterBottom>
                                <i>Objectives</i>
                            </Typography>
                            <Typography variant='b1' fontFamily="Segoe UI">
                            <b>•</b> Integrate the computational aspects of biochemical and biological problems in bioinformatics.<br/>
                            <b>•</b> Assess appropriate computational tools to address key bioinformatics questions.<br/>
                            <b>•</b> Evaluate ethical principles involved in addressing bioinformatics issues<br/>
                            <b>•</b> Develop techniques or technologies relevant in solving bioinformatics problems through independent research.<br/>
                            </Typography>
                            <Divider sx={{borderBottomWidth: 2, borderBottomColor:'black', marginTop: 2, width:"100%", marginBottom: 2}}/>

                            <Typography variant='h5' fontFamily="Segoe UI" fontWeight={700} gutterBottom>
                                PROGRAM ADMISSIONS
                            </Typography>

                            <Typography variant='h6' fontFamily="Segoe UI" fontWeight={700} gutterBottom>
                                <i>Admission Requirements</i>
                            </Typography>
                            <Typography variant='b1' fontFamily="Segoe UI">
                                I. The applicant must have a Bachelor's (or higher) degree in a field related to Computing, Life or Physical Sciences, or allied fields from a recognized institution.<br/><br/>

                                II. Must have taken the following foundational courses:<br/>
                            </Typography>
                            <List>
                                <ListItem sx={{display:'list-item', fontFamily: 'Segoe UI', marginBottom: -1}}> <b>• </b>Calculus and Matrix Algebra (e.g. Stat 100, or its equivalent)</ListItem>
                                <ListItem sx={{display:'list-item', fontFamily: 'Segoe UI', marginBottom: -1}}> <b>• </b>Probability and Statistics (e.g. Stat 195, or its equivalent)</ListItem>
                                <ListItem sx={{display:'list-item', fontFamily: 'Segoe UI', marginBottom: -1}}> <b>• </b>Computational skills or experience familiar with at least one programming language (e.g. CS 11/ES 26 or its equivalent)</ListItem>
                                <ListItem sx={{display:'list-item', fontFamily: 'Segoe UI', marginBottom: -1}}> <b>• </b>Biochemistry (Chem 40 or its equivalent)</ListItem>
                                <ListItem sx={{display:'list-item', fontFamily: 'Segoe UI', marginBottom: -1}}> <b>• </b>Introductory Biology (Bio 11 or its equivalent)</ListItem><br/>
                            </List>
                            <Typography variant='b1' fontFamily="Segoe UI">
                                III. At least two recommendation letters from former professors and/or employers (at least one from a former professor) in support with your application. [NB: The application portal will provide the recommendation letter link, no need for a template]<br/>
                            </Typography>
                            <Typography sx = {{mt: 1}} variant='h6' fontFamily="Segoe UI" fontWeight={700} gutterBottom>
                                <i>Required Documents</i>
                            </Typography>
                            <Typography variant='b1' fontFamily="Segoe UI">
                                I. Scanned official transcript of records of undergraduate (and graduate studies, if applicable) from all universities attended<br/><br/>
                                II. Scanned PSA Birth Certificate (for Filipino applicants) or Scanned Passport data page (for foreign applicants) <br/><br/>
                                III. Recent formal photo (preferrably passport photo)<br/><br/>
                                IV. An application fee of P100.00 for Filipino citizens, or $20.00 for resident foreign applicants to be paid through bank transfer or at the Cashier's Office, UP Diliman, Quezon City.<br/><br/>
                                V. <i>For Foreign Applicants:</i> Certification of English language proficiency - Official Test of English as a Foreign Language score report.<br/><br/>
                                VI. <i>For Non-UP Graduates:</i> Honorable Dismissal/Transfer Credentials 
                            </Typography>

                            <Typography  sx={{mt:2}}  variant='h6' fontFamily="Segoe UI" fontWeight={700} gutterBottom>
                                <i>Admissions Exam</i>
                            </Typography>
                            <Typography variant='b1' fontFamily="Segoe UI">
                                A diagnostic exam will be <b>given after admission to students who may not have the appropriate undergraduate foundation courses. </b> 
                                Coverage will include the same listed undergraduate courses above in <i>Admission Requirements II.</i><br/><br/>
                                The Program Committee may include these refresher subjects in the Program of Study as non-credit courses for students who failed the diagnostics tests for these respective undergraduate foundation courses. Students taking these courses are considered Non-Degree students.<br/>
                            </Typography>

                            <Divider sx={{borderBottomWidth: 2, borderBottomColor:'black', marginTop: 2, width:"100%", marginBottom: 2}}/>

                            <Typography variant='h5' fontFamily="Segoe UI" fontWeight={700} gutterBottom marginTop={2}>
                                PROGRAM COURSE STRUCTURE [37 units]
                            </Typography>
                            <Typography sx={{mt:2}} variant='h6' fontFamily="Segoe UI" fontWeight={700} gutterBottom>
                            <i>Core Courses [15 units]</i>
                            </Typography>
                            <Grid item xs={12} md={10} sx={{textAlign: 'justify'}}>
                                <TableContainer component={Paper} sx={{flexGrow:1}}>
                                    <Table sx={{width:1}} aria-label='simple table'>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align='left'><b>Bioinfo</b></TableCell>
                                                <TableCell align='left'><b>Course Name</b></TableCell>
                                                <TableCell align='left'><b>Description</b></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {core.map((core) => (
                                                <TableRow
                                                key={core.name}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                    <TableCell component="th" scope="row">{core.Bioinfo}</TableCell>
                                                    <TableCell align='left'>{core.Name}</TableCell>
                                                    <TableCell align="left" sx={{flexGrow:1}}>{core.Description}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                            <Typography sx={{mt:2}} variant='h6' fontFamily="Segoe UI" fontWeight={700} gutterBottom>
                                <i>Required Courses [10 units]</i>
                            </Typography>
                            <Grid item xs={12} md={10} sx={{textAlign: 'justify'}}>
                                <TableContainer component={Paper} sx={{flexGrow:1}}>
                                    <Table sx={{width:1}} aria-label='simple table'>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align='left'><b>Bioinfo</b></TableCell>
                                                <TableCell align='left'><b>Course Name</b></TableCell>
                                                <TableCell align='left'><b>Description</b></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {required.map((required) => (
                                                <TableRow
                                                key={core.name}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                    <TableCell component="th" scope="row">{required.Bioinfo}</TableCell>
                                                    <TableCell align='left'>{required.Name}</TableCell>
                                                    <TableCell align="left" sx={{flexGrow:1}}>{required.Description}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                            <Typography sx={{mt:2}} variant='h6' fontFamily="Segoe UI" fontWeight={700} gutterBottom>
                                <i>Electives [12 units]</i>
                            </Typography>
                            <Typography variant='b1' fontFamily="Segoe UI">
                                [Graduate courses (200/300 level) from Bioinformatics (e.g., Bioinfo 221 Genomic and Transcriptomic Bioinformatics, Bioinfo 297 Special Topics in Bioinformatics),
                                Computer Science, Engineering, Mathematics, Natural Sciences and Social Sciences, taken in consultation with the program adviser.]
                            </Typography>

                            <Divider sx={{borderBottomWidth: 2, borderBottomColor:'black', marginTop: 2, width:"100%", marginBottom: 2}}/>

                            <Typography variant='h5' fontFamily="Segoe UI" fontWeight={700} gutterBottom marginTop={2}>
                                PROGRAM CURRICULUM
                            </Typography>
                            <Typography variant='h6' fontFamily="Segoe UI" fontWeight={700} gutterBottom marginTop={2}>
                                <i>First Year</i>
                            </Typography>
                            <TableContainer component={Paper} sx={{flexGrow:1}}>
                                <Table sx={{width:1}} aria-label='simple table'>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align='left'><b>First Semester</b></TableCell>
                                            <TableCell align='left'><b>12 Units</b></TableCell>
                                            <TableCell align='left'><b>Second Semester</b></TableCell>
                                            <TableCell align='left'><b>10 Units</b></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {first.map((first) => (
                                            <TableRow
                                            key={first.name}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell component="th" scope="row">{first.S1}</TableCell>
                                                <TableCell align='left'>{first.U1}</TableCell>
                                                <TableCell align="left">{first.S2}</TableCell>
                                                <TableCell align="left">{first.U2}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <Typography variant='h6' fontFamily="Segoe UI" fontWeight={700} gutterBottom marginTop={4}>
                                <i>Second Year</i>
                            </Typography>
                            <TableContainer component={Paper} sx={{flexGrow:1}}>
                                <Table sx={{width:1}} aria-label='simple table'>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align='left'><b>First Semester</b></TableCell>
                                            <TableCell align='left'><b>12 Units</b></TableCell>
                                            <TableCell align='left'><b>Second Semester</b></TableCell>
                                            <TableCell align='left'><b>3 Units</b></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {second.map((second) => (
                                            <TableRow
                                            key={second.name}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell component="th" scope="row">{second.S1}</TableCell>
                                                <TableCell align='left'>{second.U1}</TableCell>
                                                <TableCell align="left">{second.S2}</TableCell>
                                                <TableCell align="left">{second.U2}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <Typography sx = {{mt: 5}}variant='h5' fontFamily="Segoe UI" fontWeight={700} gutterBottom marginTop={2}>
                                APPLY NOW
                            </Typography>
                            <Typography variant='b1' fontFamily="Segoe UI">
                            For the application portal visit <a href="http://ngse.upd.edu.ph/"  style={{color: '#7B1113'}}>UPD NGSE Online Application</a>. <br/>
                            <b>Deadline for Application:</b> June 30, 2023 11:59 PM<br/>
                            Classes Start August 2023<br/><br/>

                            For further inquiries you may contact DCS through <a href="mailto: info@dcs.upd.edu.ph"  style={{color: '#7B1113'}}>info@dcs.upd.edu.ph</a>
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            <FooterDefault /> 
        </ThemeProvider>
    )
}

export default MSBI